"use client";

import React, { createContext, useContext, useState, useCallback, ReactNode, useEffect } from "react";
import MFAModal from "@components/mfa-modal/MFAModal";
import Cookies from "js-cookie";

interface MFAContextType {
  showMFAModal: boolean;
  openMFAModal: () => void;
  closeMFAModal: () => void;
}

const MFAContext = createContext<MFAContextType | undefined>(undefined);

export const MFAProvider = ({ children }: { children: ReactNode }) => {
  const [showMFAModal, setShowMFAModal] = useState(false);
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);

    // Disable the old MFA logout modal
    // MFA setup is now handled in the login flow
    setShowMFAModal(false);
  }, []);

  const openMFAModal = useCallback(() => {
    setShowMFAModal(true);
  }, []);

  const closeMFAModal = useCallback(() => {
    // MFA modal cannot be closed normally, but we provide this for completeness
    setShowMFAModal(false);
  }, []);

  return (
    <MFAContext.Provider value={{ showMFAModal, openMFAModal, closeMFAModal }}>
      {children}
      {/* Old MFA modal disabled - MFA setup is now handled in login flow */}
      {/* {isMounted && <MFAModal opened={showMFAModal} />} */}
    </MFAContext.Provider>
  );
};

export const useMFA = () => {
  const context = useContext(MFAContext);
  if (!context) {
    throw new Error("useMFA must be used within MFAProvider");
  }
  return context;
};
